import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stories-carousel',
  templateUrl: './stories-carousel.component.html',
  styleUrls: ['./stories-carousel.component.scss', '../../styles/common-styles.scss'],
})
export class StoriesCarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const trustbox = document.getElementsByClassName('trustpilot-widget');
    if ((window as any).Trustpilot)
      (window as any).Trustpilot.loadFromElement(trustbox[trustbox.length - 1]);
  }
}
